export const storageTypeSelectOptions = [
    { label: 'Pallets', value: 'Pallets' },
    { label: 'Floor Space in sqm', value: 'Floor Space' },
]

export const storageType3PLSerchSelectOptions = [
    { label: 'Pallets', value: 'Pallets' },
    { label: 'Floor Space', value: 'Floor' },
    { label: 'Hardstand', value: 'Hardstand' },
]

export const storageTypeOptions = [
    { label: 'Pallets (racked)', value: 'Pallets' },
    { label: 'Floor (bulk or blockstack)', value: 'Floor' },
    { label: 'Hardstand', value: 'Hardstand' },
]

export const storageTypeCheckboxOptions = [
    { label: 'Palletized', value: 'is_palletized' },
    { label: 'Floorspace (sqm)', value: 'is_floorspace' },
    { label: 'Hardstand (sqm)', value: 'is_hardstand' },
]

export const storageTypeCheckboxOptionsForWarehouseForm = [
    { label: 'Pallets (racked)', value: 'pallets_racked' },
    { label: 'Floorspace (bulk/blockstack)', value: 'floorspace_bulk' },
    { label: 'Hardstand', value: 'hardstand' },
]

export const leaseTypeOptions = [
    { label: 'Prefer direct warehouse lease', value: 'is_direct_lease_type' },
    {
        label: 'Open to sub-leasing space in a warehouse',
        value: 'is_sublease_lease_type',
    },
]

export const rackingAndColdStorageOptions = [
    {
        label: 'Prefer existing pallet racking?',
        value: 'prefer_existing_pallet_racking',
    },
    {
        label: 'Cold storage / temp control required',
        value: 'cold_storage_required',
    },
]

export const rackingOptionsForSublease = [
    { label: 'Existing racking', value: 'existing' },
    { label: 'No racking provided', value: 'none' },
]

export const storageLengthOptions = [
    { label: '1 month', value: '1 month' },
    { label: '2 months', value: '2 months' },
    { label: '3 months', value: '3 months' },
    { label: '4 months', value: '4 months' },
    { label: '5 months', value: '5 months' },
    { label: '6 months', value: '6 months' },
    { label: '6-12 months', value: '6-12 months' },
    { label: '12 months +', value: '12 months +' },
]

export const leaseTermOptions = [
    { label: '> 12 months', value: '> 12 months' },
    { label: '1-3 years', value: '1-3 years' },
    { label: '3-5 years', value: '3-5 years' },
    { label: '5-7 years', value: '5-7 years' },
    { label: '7 years +', value: '7 years +' },
]

export const palletLeaseTermOptions = [
    { label: '<12 months', value: '<12 months' },
    { label: '1-3 years', value: '1-3 years' },
    { label: '3-5 years', value: '3-5 years' },
    { label: '5-7 years', value: '5-7 years' },
    { label: '7 years+', value: '7 years+' },
]

export const quoteValidityPeriodOptions = [
    { label: '7 days', value: 7 },
    { label: '14 days', value: 14 },
    { label: '30 days', value: 30 },
]

export const loadingDocksOptions = [
    { label: '0', value: '0' },
    { label: '1', value: '1' },
    { label: '2', value: '2' },
    { label: '3', value: '3' },
    { label: '4', value: '4' },
    { label: '5', value: '5' },
    { label: '6', value: '6' },
    { label: '6+', value: '6+' },
]

export const palletLoadingDocksOptions = [
    { label: '0', value: '0' },
    { label: '1+', value: '1+' },
    { label: '2+', value: '2+' },
    { label: '3+', value: '3+' },
    { label: '4+', value: '4+' },
]

export const palletRollerDoorsOptions = [
    { label: '1+', value: '1+' },
    { label: '2+', value: '2+' },
    { label: '3+', value: '3+' },
    { label: '4+', value: '4+' },
    { label: '5+', value: '5+' },
    { label: '6+', value: '6+' },
]

export const yesNoOptions = [
    { label: 'Yes', value: 'Yes' },
    { label: 'No', value: 'No' },
]

export const filterOptions = [
    { label: 'All', value: 'All' },
    { label: 'Available', value: 'Available' },
    { label: 'Unavailable', value: 'Unavailable' },
]

export const isOnOlmOptions = [
    { label: 'All', value: 'All' },
    { label: 'Public', value: 'Yes' },
    { label: 'Unlisted', value: 'No' },
]

export const accreditationsOptions = [
    'AQIS',
    'EPA',
    'Refrigerated',
    'Dairy',
    'Frozen',
    'Temp Controlled',
    'Dangerous goods',
    'HACCP approved',
    'TGA',
]

export const servicesOptions = [
    { value: 'freight_transport', label: 'Freight / Transport' },
    { value: 'international_freight', label: 'International Freight' },
    { value: 'customs_brokerage', label: 'Customs Brokerage' },
    { value: 'wharf_transport', label: 'Wharf Transport' },
    { value: 'cross_dock', label: 'Cross Dock' },
    { value: 'last_mile_b2b', label: 'Last Mile (B2B)' },
    { value: 'last_mile_b2c', label: 'Last Mile (B2C)' },
    { value: 'pick_pack', label: 'Pick & Pack' },
    { value: 'labelling', label: 'Labelling' },
    { value: 'kitting', label: 'Kitting' },
    { value: 'shrink_wrapping', label: 'Shrink Wrapping' },
    { value: 'pallet_strapping', label: 'Pallet Strapping' },
    { value: 'value_added_services', label: 'Value added services' },
]

export const storageCapabilitiesOptions = [
    { value: 'ambient', label: 'Ambient' },
    { value: 'temp_controlled', label: 'Temp controlled' },
    { value: 'chilled', label: 'Chilled' },
    { value: 'frozen', label: 'Frozen' },
    { value: 'dairy', label: 'Dairy' },
    { value: 'haccp', label: 'HACCP' },
    { value: 'tga', label: 'Therapeutic Goods Association (TGA)' },
    { value: 'epa', label: 'EPA' },
    { value: 'aqis', label: 'AQIS' },
    { value: 'bonded', label: 'Bonded' },
    { value: 'e_comm', label: 'E-comm integration' },
    { value: 'industrial_bulky', label: 'Industrial / Bulky' },
    { value: 'whitegoods', label: 'Whitegoods' },
    { value: 'automated', label: 'Automated' },
]

export const dangerousGoodsOptions = [
    { value: 'cl_1_explosives', label: 'Class 1 - Explosives' },
    { value: 'cl_2_gasses', label: 'Class 2 - Gasses' },
    { value: 'cl_3_flammable_liquids', label: 'Class 3 - Flammable Liquids' },
    { value: 'cl_4_flammable_solids', label: 'Class 4 - Flammable solids' },
    {
        value: 'cl_5_oxidising_substances',
        label: 'Class 5 - Oxidising substances & organics',
    },
    {
        value: 'cl_6_toxic_infectious',
        label: 'Class 6 - Toxic & infectious substances',
    },
    { value: 'cl_7_radioactive', label: 'Class 7 - Radioactive materials' },
    { value: 'cl_8_corrosives', label: 'Class 8 - Corrosives' },
    { value: 'cl_9_miscellaneous', label: 'Class 9 - Miscellaneous' },
]

export const requestRequirementOptions = [
    ...storageCapabilitiesOptions,
    ...servicesOptions,
    ...dangerousGoodsOptions,
]

export const servicesOfferedOptions = [
    { label: 'International Freight', value: 'International Freight' },
    { label: 'Customs Brokerage', value: 'Customs Brokerage' },
    { label: 'Wharf Transport', value: 'Wharf Transport' },
    { label: 'Pick & Pack', value: 'Pick & Pack' },
    { label: 'Last Mile Fulfilment', value: 'Last Mile Fulfilment' },
    { label: 'Cross Dock', value: 'Cross Dock' },
    { label: 'Kitting', value: 'Kitting' },
    { label: 'Labelling', value: 'Labelling' },
    { label: 'Value added services', value: 'Value Added Services (VAS)' },
]

export const storageOfferingOption = [
    { label: 'Ambient', value: 'Ambient' },
    { label: 'Temp controlled', value: 'Temp controlled' },
    { label: 'Chilled', value: 'Chilled' },
    { label: 'Frozen', value: 'Frozen' },
    { label: 'Dairy', value: 'Dairy' },
    { label: 'HACCP', value: 'HACCP approved' },
    { label: 'Dangerous goods', value: 'Dangerous goods' },
    { label: 'TGA', value: 'TGA' },
    { label: 'Bonded', value: 'Bonded' },
    { label: 'Retail', value: 'Retail' },
    { label: 'E-Commerce', value: 'E-Commerce' },
    { label: 'Industrial', value: 'Industrial' },
    { label: 'AQIS', value: 'AQIS' },
]

export const minJobSizeOption = [
    { label: '1000 pallets', value: '1000+' },
    { label: '500 pallets', value: '500+ pallets' },
    { label: '100 pallets', value: '100+ pallets' },
    { label: '50 pallets', value: '50+ pallets' },
    { label: '1 pallet', value: '1+ pallets' },
]

export const maxJobSizeOption = [
    { label: '1,000+ pallets', value: '1,000 pallets +' },
    { label: '500 pallets', value: '500 pallets' },
    { label: '100 pallets', value: '100 pallets' },
    { label: '50 pallets', value: '50 pallets' },
    { label: '10 pallets', value: '10 pallets' },
]

export const palletMinJobSizeOption = [
    { label: '1000+ pallets', value: '1000+' },
    { label: '500+ pallets', value: '500+' },
    { label: '100+ pallets', value: '100+' },
    { label: '50+ pallets', value: '50+' },
    { label: '1+ pallets', value: '1+' },
]

export const palletMaxJobSizeOption = [
    { label: '1,000+ pallets', value: '1000+' },
    { label: '500 pallets', value: '500' },
    { label: '100 pallets', value: '100' },
    { label: '50 pallets', value: '50' },
    { label: '10 pallets', value: '10' },
]

export const countryOptions = [
    {
        label: 'Australia',
        value: 'AU',
        states: [
            { label: 'Australian Capital Territory', value: 'ACT' },
            { label: 'New South Wales', value: 'NSW' },
            { label: 'Northern Territory', value: 'NT' },
            { label: 'Queensland', value: 'QLD' },
            { label: 'South Australia', value: 'SA' },
            { label: 'Tasmania', value: 'TAS' },
            { label: 'Victoria', value: 'VIC' },
            { label: 'Western Australia', value: 'WA' },
        ],
    },
    {
        label: 'New Zealand',
        value: 'NZ',
        states: [
            { label: 'Auckland Region', value: 'AUK' },
            { label: 'Bay of Plenty Region', value: 'BOP' },
            { label: 'Canterbury Region', value: 'CAN' },
            { label: 'Chatham Islands', value: 'CIT' },
            { label: 'Gisborne District', value: 'GIS' },
            { label: "Hawke's Bay Region", value: 'HKB' },
            { label: 'Manawatu-Wanganui Region', value: 'MWT' },
            { label: 'Marlborough Region', value: 'MBH' },
            { label: 'Nelson Region', value: 'NSN' },
            { label: 'Northland Region', value: 'NTL' },
            { label: 'Otago Region', value: 'OTA' },
            { label: 'Southland Region', value: 'STL' },
            { label: 'Taranaki Region', value: 'TKI' },
            { label: 'Tasman District', value: 'TAS' },
            { label: 'Waikato Region', value: 'WKO' },
            { label: 'Wellington Region', value: 'WGN' },
            { label: 'West Coast Region', value: 'WTC' },
        ],
    },
]

export const userTypeOption = [
    { label: 'Supplier', value: 'supplier' },
    { label: 'Tenant', value: 'tenant' },
    { label: 'Landlord', value: 'landlord' },
]

export const partnerTiersOption = [
    { label: 'Tier 1', value: 'tier_1' },
    { label: 'Tier 2', value: 'tier_2' },
    { label: 'Tier 3', value: 'tier_3' },
    { label: 'Tier 4', value: 'tier_4' },
    { label: 'Blacklist', value: 'blacklist' },
]

export const serchTiersOption = [
    { label: 'Tier 1', value: 1 },
    { label: 'Tier 2', value: 2 },
    { label: 'Tier 3', value: 3 },
    { label: 'Tier 4', value: 4 },
    { label: 'Blacklist', value: 0 },
]

export const accessLevelOptions = [
    { label: 'Full access', value: 'admin' },
    {
        label: 'Restricted access (no account level or delegate access)',
        value: 'delegate',
    },
    { label: 'Read-only access', value: 'viewer' },
]

export const ratecardTypeOptions = [
    { label: 'Global Ratecard', value: 'global_default' },
    { label: 'Location Ratecard', value: 'location_specific' },
]

export const getStateOptions = (country) => {
    switch (country) {
        case 'AU':
            return AUSTRALIAN_STATES
        case 'NZ':
            return NEW_ZEALAND_REGIONS
        default:
            return []
    }
}

export const AUSTRALIAN_STATES = [
    { value: 'NSW', label: 'New South Wales' },
    { value: 'VIC', label: 'Victoria' },
    { value: 'QLD', label: 'Queensland' },
    { value: 'WA', label: 'Western Australia' },
    { value: 'SA', label: 'South Australia' },
    { value: 'TAS', label: 'Tasmania' },
    { value: 'ACT', label: 'Australian Capital Territory' },
    { value: 'NT', label: 'Northern Territory' },
]

export const NEW_ZEALAND_REGIONS = [
    { value: 'northland', label: 'North Island' },
    { value: 'southland', label: 'South Island' },
]

export const COUNTRIES = [
    { value: 'AU', label: 'Australia 🇦🇺' },
    { value: 'NZ', label: 'New Zealand 🇳🇿' },
    { value: 'INT', label: 'International 🌍' },
]

export const profileTypeOptions = [
    { label: 'All Customers', value: 'all_customers' },
    { label: 'All Suppliers', value: 'all_suppliers' },
    { label: 'Whole Platform', value: 'whole_platform' },
]

export const senderOptions = [
    { label: 'uTenant Support', value: 'support' },
    { label: 'Your Name', value: 'user' },
]

export const messageTypeOptions = [
    { label: 'Notification', value: 'Notification' },
    { label: 'uTenant Update', value: 'uTenant Update' },
    { label: 'System Notification', value: 'System Notification' },
]

export const logisticsProviderTypesOptions = [
    { label: '3PL (Warehousing)', value: '3pl_warehousing' },
    { label: 'Freight Forwarding', value: 'freight_forwarding' },
    { label: 'Transport', value: 'transport' },
    { label: 'Cartage', value: 'cartage' },
    { label: '4PL', value: '4pl' },
    { label: 'Brokerage', value: 'brokerage' },
]